export default "__VITE_ASSET__Bs_qH10j__"